import { render, staticRenderFns } from "./LangusgeSwitcher.vue?vue&type=template&id=3875d3d8&"
import script from "./LangusgeSwitcher.vue?vue&type=script&lang=ts&"
export * from "./LangusgeSwitcher.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports